export enum CriteriaModalityEnum {
    DUAS_EQUIPES = 'DUAS_EQUIPES',
    MAIS_DE_TRES_EQUIPES = 'MAIS_DE_TRES_EQUIPES',
}
